var map = {
	"./backendIcon.png": 112,
	"./cloudIcon2.png": 485,
	"./databaseIcon.png": 971,
	"./devopsIcon.png": 772,
	"./frontendIcon.png": 428,
	"./mlIcon.png": 551,
	"./securityIcon.png": 138,
	"./testingIcon.png": 564,
	"./uiuxIcon.png": 593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;